import { render, staticRenderFns } from "./AlterPlace.vue?vue&type=template&id=4037eede&scoped=true&"
import script from "./AlterPlace.vue?vue&type=script&lang=js&"
export * from "./AlterPlace.vue?vue&type=script&lang=js&"
import style0 from "./AlterPlace.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AlterPlace.vue?vue&type=style&index=1&id=4037eede&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4037eede",
  null
  
)

export default component.exports